export default "__VITE_ASSET__85CJ5zxS__"